export const AUTH_CONSTANTS = {
  JWT_TOKEN: 'accessToken',
  JWT_REFRESH_TOKEN: 'refreshToken',
  LOGOUT_COMPLETED: 'Logout Completed.',
};
